<template>
  <div class="product-info">
    <div class="detail-container">
      <img v-lazy="productItem.imgUrl" alt="" />
      <div class="detail">
        <div class="title lc-2">{{ productItem.name }}</div>
        <div class="price">
          <span class="estimated-label" v-if="hasEstimatedPrice">到手预估</span>
          <span class="sale-price" v-text="price1"></span>
          <template v-if="price2">
            <span class="line-price">￥{{ price2 }}</span>
            <!-- <span class="discount-desc">省{{ Number(savePrice) }}元</span> -->
          </template>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="cart-btn" :class="{ opc: disabledCartBtn }">
        <img src="~assets/img/product/detail/icon-shopcart-grey.png" alt="" @click.stop="addToCart" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'productItem',
  props: {
    disabledCartbtnIds: {
      type: Array,
      default: () => []
    },
    // 加购商品spu维度信息，包含sku
    productItem: {
      type: Object,
      default: () => {}
    },
    // 已选加购商品sku信息
    additionSkuList: {
      type: Array,
      default: () => []
    },

    trackSource: [Number, String]
  },
  data() {
    return {}
  },
  computed: {
    disabledCartBtn() {
      return this.disabledCartbtnIds.includes(this.productItem.id)
    },
    hasEstimatedPrice(){
      const {estimatedPrice,salePrice} = this.productItem
      return estimatedPrice && estimatedPrice < salePrice
    },
    price1(){
      const {estimatedPrice,salePrice,marketPrice} = this.productItem
      if(this.hasEstimatedPrice) return estimatedPrice
      return salePrice || marketPrice
    },
    price2(){
      const {salePrice,marketPrice} = this.productItem
      if(this.hasEstimatedPrice) return salePrice
      if(salePrice && salePrice < marketPrice) return marketPrice
      return ''
    },
    // savePrice(){
    //   if(this.price2){
    //     return parseFloat(this.price2 - this.price1).toFixed(2)
    //   }
    // }
  },
  methods: {
    addToCart() {
      if (this.disabledCartBtn) {
        return this.$toast('该商品已加入购物车')
      }
      // skuItem 为选中的sku
      this.$emit('addToCart', this.productItem)
    }
  }
}
</script>

<style lang="scss" scoped>
.product-info {
  height: fit-content;
  @include bgColor(rgba(249, 249, 249, 1), rgba(255, 255, 255, 0.1));
  padding: 36px;
  margin-top: 30px;
  border-radius: 39px;
  display: flex;
  align-items: center;
  .detail-container {
    flex: 1;
    display: flex;
    img {
      width: 150px;
      height: 150px;
      border-radius: 12.5px;
      @include bgColor(unset, rgba(255, 255, 255, 0.05));
    }
  }
  .right {
    margin-left: 20px;
    .cart-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 72px;
      height: 72px;
      border-radius: 35px;
      background: #eeeeee;

      img {
        width: 48px;
        height: 48px;
      }
      &.opc {
        opacity: 0.4;
      }
    }
  }
}
.detail {
  margin-left: 33px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .title {
    font-size: 36px;
    line-height: 46px;
    margin-bottom: 24px;
    @include os-font-weight(36, 40);
    @include fontColor(#252525, rgba(255, 255, 255, 0.9));
  }
  .price {
    .estimated-label{
      position: relative;
      font-size: 30px;
      color: #252525;
      margin-right: 3px;
      bottom: 2px;
    }
    .sale-price {
      font-size: 36px;
      font-weight: 500;
      letter-spacing: 0px;
      @include fontColor(rgba(0, 0, 0, 0.84), rgba(255, 255, 255, 0.9));
      @include os-font-weight(36, 50);
      &::before {
        content: '￥';
        font-size: 30px;
        @include os-font-weight(30, 40);
      }
    }
    .line-price {
      margin-left: 6px;
      font-size: 30px;
      letter-spacing: 0px;
      @include fontColor(rgba(187, 187, 187, 1), rgba(255, 255, 255, 0.35));
      @include os-font-weight(30, 40);
      text-decoration: line-through;
    }
    .discount-desc {
      margin-left: 12px;
      font-size: 30px;
      font-weight: 400;
      @include fontColor(rgba(241, 3, 19, 1), rgba(241, 3, 19, 0.9));
      @include os-font-weight(30, 40);
    }
  }
  .sku-info {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-right: -30px;
    max-height: 190px;
    overflow: hidden;
    .sku-item {
      height: 72px;
      padding: 18px 51px;
      box-sizing: border-box;
      @include fontColor(rgba(37, 37, 37, 1), rgba(255, 255, 255, 0.9));
      font-size: 30px;
      border-radius: 36px;
      @include bgColor(rgba(238, 238, 238, 1), rgba(255, 255, 255, 0.05));
      margin-right: 30px;
      margin-bottom: 24px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      @include os-font-weight(30, 40);
      &.selected {
        padding: 15px 48px;
        @include borderColor(1111, 3px, solid, rgba(241, 3, 19, 1), rgba(241, 3, 19, 0.9));
        @include bgColor(rgba(255, 244, 245, 1), rgba(241, 3, 19, 0.05));
        color: rgba(241, 3, 19, 1);
      }
    }
    .show-more {
      height: 72px;
      padding: 18px 21px;
      color: rgba(153, 153, 153, 1);
      display: flex;
      align-items: flex-end;
      .icon {
        height: 30px;
        width: 18px;
        color: #cccccc;
        margin: 0px 10px;
        transform: rotate(-90deg);
      }
    }
    &.sku-info-more {
      height: fit-content;
      max-height: unset;
    }
  }
}
</style>
